import API from '../../api/api';
import * as actionTypes from '../actionTypes';
import {message} from 'antd';

function salvaStep(pratica,uuid,broker,stepCorrente,apiPath,numPratica) {
    return (dispatch) => {
        API.getAxios(apiPath).put(`/pratica/${uuid}`,{
            id: uuid,
            numPratica: numPratica,
            codiceBroker:broker,
            currentStep: stepCorrente,
            datiPratica: pratica
        })
        .then(response => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ 'event': 'preventivatore', 'step': `${stepCorrente}`});
            dispatch({type: actionTypes.SAVE_DATA, payload: response.data});
            dispatch({type: actionTypes.LOADING_FALSE });
            dispatch({type: actionTypes.STEP_AVANTI});
        })
        .catch(errore => { 
            dispatch({ type: actionTypes.ERROR_SALVA_STEP, payload: errore.response.data});
            dispatch({type: actionTypes.LOADING_FALSE});
        })
    };
}

export function salvaStepSkipping(pratica,uuid,broker,stepCorrente,apiPath,numPratica) {
    return (dispatch) => {
        API.getAxios(apiPath).put(`/pratica/${uuid}`,{
            id: uuid,
            numPratica: numPratica,
            codiceBroker:broker,
            currentStep: stepCorrente + 1,
            datiPratica: pratica
        })
        .then(response => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ 'event': 'preventivatore', 'step': `${stepCorrente + 1}`});
            dispatch({type: actionTypes.SAVE_DATA, payload: response.data});
            dispatch({type: actionTypes.LOADING_FALSE });
            dispatch({type: actionTypes.STEP_AVANTI});
        })
        .catch(errore => {
            if(errore.response.status !== 500){
                dispatch({ type: actionTypes.ERROR_SALVA_STEP, payload: errore.response.data});
            }else{
                message.error('ERRORE DEL SERVER, RITENTA..',5);
            }
            dispatch({type: actionTypes.LOADING_FALSE });
        })
    };
}

export function salvaStepOnly(pratica,uuid,broker,stepCorrente,apiPath,numPratica) {
    return (dispatch) => {
        API.getAxios(apiPath).put(`/pratica/${uuid}`,{
            id: uuid,
            numPratica: numPratica,
            codiceBroker:broker,
            currentStep: stepCorrente,
            datiPratica: pratica
        })
        .then(response => {
            dispatch({type: actionTypes.SAVE_DATA, payload: response.data});
            // dispatch({type: actionTypes.LOADING_FALSE });
        })
        .catch(errore => {
            dispatch({ type: actionTypes.ERROR_SALVA_STEP, payload: errore.response.data});
            dispatch({type: actionTypes.LOADING_FALSE });
        })
    };
}

export async function salvaStepOnlyPromise(pratica,uuid,broker,stepCorrente,apiPath,numPratica) {
    return new Promise(async (resolve, reject) => {
        API.getAxios(apiPath).put(`/pratica/${uuid}`,{
            id: uuid,
            numPratica: numPratica,
            codiceBroker:broker,
            currentStep: stepCorrente,
            datiPratica: pratica
        })
        .then(response => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ 'event': 'preventivatore', 'step': `${stepCorrente}`});
            resolve(response.data)
        })
        .catch(error => {
            reject(error.response.data);
        })
    })
}

export function salvaCurrentStep(uuid, apiPath, step) {
    return (dispatch) => {
        API.getAxios(apiPath).put(`/pratica/${uuid}/update-step/${step}`)
            .then(response => {
                dispatch({type: actionTypes.SAVE_DATA, payload: response.data});
            })
            .catch(errore => {
                dispatch({ type: actionTypes.ERROR_SALVA_STEP, payload: errore.response.data});
                dispatch({type: actionTypes.LOADING_FALSE });
            })
    }
}

export default salvaStep;